import { useCallback, useEffect, useMemo, useState } from "react"
import { isOutsideHint, toggledOpenCode } from "@/hooks/useAmountHint/helpers"
import { IAmountHint } from "@/hooks/useAmountHint/types"

export const useAmountHint = (): IAmountHint => {
  const [openCode, setOpenCode] = useState<string | null>(null)

  const toggle = useCallback(
    (code: string) => setOpenCode((open) => toggledOpenCode(open, code)),
    []
  )
  const close = useCallback(() => setOpenCode(null), [])

  useEffect(() => {
    if (openCode === null) return
    const onPointerDown = (event: PointerEvent) => {
      if (isOutsideHint(event.target)) {
        close()
      }
    }
    document.addEventListener("pointerdown", onPointerDown)
    return () => document.removeEventListener("pointerdown", onPointerDown)
  }, [openCode, close])

  return useMemo(() => ({ openCode, toggle, close }), [openCode, toggle, close])
}
